import { Col, notification, Row } from "antd";
import * as React from "react";
import { useContext, useEffect, useState } from "react";
import { RouteComponentProps, withRouter } from "react-router";
import { ContainerWrapper } from "src/components/common/ContainerWrapper/ContainerWrapper";
import Loading from "src/components/common/Loading";
import { IStep } from "src/components/common/StepByStep/StepByStep";
import VerticalStepByStep from "src/components/common/StepByStep/VerticalStepByStep";
import Certificates from "src/pages/step-flow/steps/certificates/Certificates";
import ContractInfo from "src/pages/step-flow/steps/contract-info/ContractInfo";
import Documents from "src/pages/step-flow/steps/documents/Documents";
import DocumentsValidation from "src/pages/step-flow/steps/documents/DocumentsValidation";
import InvoiceUpload from "src/pages/step-flow/steps/invoice-upload/InvoiceUpload";
import PaymentConfirmation from "src/pages/step-flow/steps/payment/PaymentConfirmation";
import TradeRejected from "src/pages/step-flow/steps/trade-rejected/TradeRejected";
import { ITrade } from "src/services/interfaces/trade/ITrade";
import { ServiceContext } from "src/services/provider/Service.provider";
import ContractSigned from "./steps/ContractSigned/ContractSigned";
import { TradePhaseEnum } from "src/services/interfaces/trade/TradePhaseEnum";
import { TradeStatusEnum } from "src/services/interfaces/TradeStatusEnum";
import BankInfo from "./steps/bank-info/BankInfo";
import DocumentsAnalysis from './steps/documents-analysis/DocumentsAnalysis';

function StepFlow(props: RouteComponentProps<any>) {
  const { tradeService } = useContext(ServiceContext);
  const [trade, setTrade] = useState<ITrade>(undefined);
  const [phase, setPhase] = useState<TradePhaseEnum>(TradePhaseEnum.Undefined);
  const [status, setStatus] = useState(TradeStatusEnum.Undefined);

  useEffect(() => {
    if (trade) {
      setPhase(trade.phase);
      setStatus(trade.status);
    } else {
      tradeService
        .getById(props.match.params.id)
        .then(setTrade)
        .catch(err => {
          console.log(err);
          notification.error({
            description: "Ocorreu um erro durante a requisição",
            message: "Parece que estamos com problemas para processar essa requisição. Por favor, tente novamente."
          });
        });
    }
  }, [trade]);

  const steps: IStep[] = [
    {
      title: "Dados para contrato",
      active: phase === TradePhaseEnum.ContractInformation || phase === TradePhaseEnum.BankInfo,
      icon: require("src/icons/dadoscontrato.svg"),
      description: "Neste passo, precisaremos de algumas informações pessoais e bancárias, essenciais para a continuidade do processo."
    },
    {
      title: "Envio de Certidões",
      active: phase === TradePhaseEnum.LegalCertificates,
      icon: require("src/icons/upload.svg"),
      description: " "
    },
    {
      title: "Upload de documento",
      active: phase === TradePhaseEnum.DocumentValidation,
      icon: require("src/icons/upload.svg"),
      description: "Neste passo, vamso precisar de um documento com foto para validação. Tenha em mãos um documento com foto, seja RG ou CNH."
    },
    {
      title: "Validação do documento",
      active: phase === TradePhaseEnum.DocumentApproval,
      icon: require("src/icons/validacao.svg"),
      description: "Estamos analisando seu documento e retornaremos em até um dia útil. Você receberá um e-mail com o status da aprovação."
    },
    {
      title: "Análise de Dados",
      active: phase === TradePhaseEnum.Analysis || phase === TradePhaseEnum.Diligence || phase === TradePhaseEnum.SpecialSituation,
      icon: require("src/icons/aguardecontato.svg"),
      description: "Vamos analisar as informações recebidas e entraremos em contato."
    },
    {
      title: "Aguarde nosso contato",
      active: phase === TradePhaseEnum.Cartorio || phase === TradePhaseEnum.PreCartorio,
      icon: require("src/icons/aguardecontato.svg"),
      description: "Entraremos em contato para agendar a visita ao cartório."
    },

    {
      title: "Envio de nota fiscal",
      active: phase === TradePhaseEnum.Funding,
      icon: require("src/icons/upload.svg"),
      description: ""
    },
    {
      title: "Pagamento Efetuado",
      active: phase === TradePhaseEnum.Payment,
      icon: require("src/icons/pagamentoefetuado.svg"),
      description: "Agradecemos a confiança, desejamos felicidades a você. Se possível, gostaríamos de ouvir sua opinião sobre o processo de negociação."
    }
  ];

  return (
    <ContainerWrapper style={{ maxWidth: "none", width: "100%", margin: "-24px 0" }}>
      <div className="steps-content-box" style={{ margin: "-24px", borderTop: "#f0f2f5 solid thin" }}>
        {trade ? (
          <Row type="flex">
            <Col xs={18} sm={18} md={18} lg={19} style={{ padding: "35px" }}>
              {(status === TradeStatusEnum.Rejeitado && <TradeRejected precatorio={trade.precatorio} trade={trade} />) ||
                (phase === TradePhaseEnum.ContractInformation && (
                  <ContractInfo precatorio={trade.precatorio} trade={trade} onChangePhase={p => setPhase(p)} setTrade={setTrade} />
                )) ||
                (phase === TradePhaseEnum.BankInfo && <BankInfo precatorio={trade.precatorio} trade={trade} onChangePhase={p => setPhase(p)} isRequired />) ||
                (phase === TradePhaseEnum.LegalCertificates && <Certificates precatorio={trade.precatorio} trade={trade} onChangePhase={p => setPhase(p)} />) ||
                (phase === TradePhaseEnum.DocumentValidation && <Documents precatorio={trade.precatorio} trade={trade} onChangePhase={p => setPhase(p)} />) ||
                (phase === TradePhaseEnum.DocumentApproval && <DocumentsValidation precatorio={trade.precatorio} trade={trade} onChangePhase={p => setPhase(p)} />) ||
                ((phase === TradePhaseEnum.Analysis || phase === TradePhaseEnum.Diligence || phase === TradePhaseEnum.SpecialSituation) && <DocumentsAnalysis precatorio={trade.precatorio} trade={trade} onChangePhase={p => setPhase(p)} />) ||
                (phase === TradePhaseEnum.Cartorio || phase === TradePhaseEnum.PreCartorio && <ContractSigned />) ||
                (phase === TradePhaseEnum.Funding && <InvoiceUpload precatorio={trade.precatorio} trade={trade} onChangePhase={p => setPhase(p)} />) ||
                (phase === TradePhaseEnum.Payment && <PaymentConfirmation precatorio={trade.precatorio} trade={trade} />)}
            </Col>
            <Col xs={6} sm={6} md={6} lg={5} style={{ backgroundColor: "#f0f2f5" }}>
              <VerticalStepByStep steps={steps} tradeRejected={trade.status === TradeStatusEnum.Rejeitado} />
            </Col>
          </Row>
        ) : (
            <Loading />
          )}
      </div>
    </ContainerWrapper>
    // </PbrCard>
  );
}

export default withRouter(StepFlow);



// WEBPACK FOOTER //
// ./src/pages/step-flow/StepFlow.tsx